import React from 'react';
import styled from '@emotion/styled';
import RadioButton from '../../components/RadioButton';

const EditOptionStyles = styled.div`
  margin-top: 8px;
  font-size: 16px;
  cursor: pointer;
  color: #444340;
  display: flex;
  align-items: center;
`;

interface Props {
    priority: string,
    onChange: (priority: string) => void
}

const Priority = (props: Props) => {
    return (
        <>
            <EditOptionStyles >
                <RadioButton
                    text='Regular'
                    selected={props.priority === 'Regular'}
                    setSelected={props.onChange} />
            </EditOptionStyles>
            <EditOptionStyles >
                <RadioButton
                    text='Rush'
                    selected={props.priority === 'Rush'}
                    setSelected={props.onChange} />
            </EditOptionStyles>
            <EditOptionStyles onClick={() => props.onChange('Super Rush')}>
                <RadioButton
                    text='Super Rush'
                    selected={props.priority === 'Super Rush'}
                    setSelected={props.onChange} />
            </EditOptionStyles>
        </>)
};

export default Priority;